import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.initializeDatePickers()
  }

  initializeDatePickers() {
    // Find all date input fields within this controller's scope
    const dateFields = this.element.querySelectorAll('input[type="date"], input[data-date-picker]')

    dateFields.forEach(dateField => {
      this.setupDateField(dateField)
    })
  }

  setupDateField(dateField) {
    // Set input type to date for modern browsers
    dateField.type = 'date'

    // Set max date to today
    const today = new Date().toISOString().split('T')[0]
    dateField.max = today

    // Add placeholder or pattern for fallback browsers
    if (dateField.type !== 'date') {
      dateField.placeholder = 'DD/MM/YYYY'
      dateField.pattern = '\\d{2}/\\d{2}/\\d{4}'
    }
  }
}
